import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function ReviewsSection() {
  const reviews = [{
    id: 1,
    author: 'Sarah',
    text: 'Friendly, efficient, and cleaned the house top to bottom. I have never been able to get carpet as clean as she did. Highly recommend!',
    rating: 5
  }, {
    id: 2,
    author: 'Peter',
    text: 'Amazing deep clean on a 4 bed house. They worked hard and we were very satisfied with the result — all for a very reasonable price.',
    rating: 5
  }, {
    id: 3,
    author: 'Sharon',
    text: "Professional, flexible, and nothing is too much trouble. They've been cleaning for me for several years now.",
    rating: 5
  }, {
    id: 4,
    author: 'Edward',
    text: 'The house is spotless and nothing was missed. Fitted around our tight schedule. Would highly recommend, very friendly team too.',
    rating: 5
  }, {
    id: 5,
    author: 'Alex',
    text: 'Excellent experience — they provided a free inspection and quote, then worked hard to fit us in. Really pleased with the results!',
    rating: 5
  }, {
    id: 6,
    author: 'Denecia',
    text: 'By far the most thorough cleaning company I have used. Punctual, efficient, professional with a keen eye for detail. Outstanding results.',
    rating: 5
  }];
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const next = useCallback(() => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % reviews.length);
  }, [reviews.length]);
  const prev = useCallback(() => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + reviews.length) % reviews.length);
  }, [reviews.length]);
  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);
  const review = reviews[current];
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 80 : -80,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -80 : 80,
      opacity: 0
    })
  };
  return <section className="bg-light py-16 md:py-24 relative z-20 border-t border-gray-100" data-id="element-220">
      <div className="container mx-auto px-6 md:px-12" data-id="element-221">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-222">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-223">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary uppercase tracking-tight mb-4" data-id="element-224">
              What Our Clients Say
            </h2>
            <p className="text-gray-600 text-lg" data-id="element-225">
              Don't just take our word for it. Read what our satisfied customers
              in Bicester and Oxfordshire have to say about our premium cleaning
              services.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex items-center gap-3 bg-white px-6 py-3 rounded-xl shadow-sm border border-gray-100" data-id="element-226">
            <div className="flex flex-col" data-id="element-227">
              <span className="text-sm font-bold text-primary" data-id="element-228">Excellent</span>
              <div className="flex items-center gap-1" data-id="element-229">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} className="text-[#FBBC05] fill-[#FBBC05]" data-id="element-230" />)}
              </div>
            </div>
            <div className="w-px h-8 bg-gray-200 mx-2" data-id="element-231"></div>
            <div className="flex items-center gap-2" data-id="element-232">
              <span className="text-2xl font-bold text-primary" data-id="element-233">5.0</span>
              <svg viewBox="0 0 24 24" className="w-6 h-6 shrink-0" data-id="element-234">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-235" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-236" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-237" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-238" />
              </svg>
            </div>
          </motion.div>
        </div>

        {/* Slider */}
        <div className="relative bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-239">
          <div className="relative min-h-[180px] md:min-h-[140px] flex items-center px-8 md:px-16 py-10" data-id="element-240">
            {/* Prev / Next buttons */}
            <button onClick={prev} aria-label="Previous review" className="absolute left-3 md:left-5 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-gray-100 hover:bg-accent/10 flex items-center justify-center transition-colors z-10" data-id="element-241">
              <ChevronLeftIcon size={18} className="text-primary" data-id="element-242" />
            </button>
            <button onClick={next} aria-label="Next review" className="absolute right-3 md:right-5 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-gray-100 hover:bg-accent/10 flex items-center justify-center transition-colors z-10" data-id="element-243">
              <ChevronRightIcon size={18} className="text-primary" data-id="element-244" />
            </button>

            <AnimatePresence mode="wait" custom={direction} data-id="element-245">
              <motion.div key={review.id} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="w-full text-center px-8" data-id="element-246">
                <div className="flex items-center justify-center gap-1 mb-3" data-id="element-247">
                  {[...Array(review.rating)].map((_, i) => <StarIcon key={i} size={16} className="text-[#FBBC05] fill-[#FBBC05]" data-id="element-248" />)}
                </div>
                <p className="text-gray-700 text-base md:text-lg leading-relaxed max-w-3xl mx-auto mb-4" data-id="element-249">
                  "{review.text}"
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-250">
                  <span className="font-bold text-primary text-sm" data-id="element-251">
                    {review.author}
                  </span>
                  <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0 opacity-70" data-id="element-252">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-253" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-254" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-255" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-256" />
                  </svg>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 pb-6" data-id="element-257">
            {reviews.map((_, index) => <button key={index} onClick={() => {
            setDirection(index > current ? 1 : -1);
            setCurrent(index);
          }} aria-label={`Go to review ${index + 1}`} className={`w-2 h-2 rounded-full transition-all duration-300 ${index === current ? 'bg-accent w-6' : 'bg-gray-300 hover:bg-gray-400'}`} data-id="element-258" />)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-10 text-center" data-id="element-259">
          <a href="https://www.google.com/search?q=smith+and+jeng+reviews+cleaning+biscester" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-bold hover:text-accent transition-colors text-sm uppercase tracking-widest" data-id="element-260">
            Read more reviews on Google
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-261">
              <path d="M5 12h14" data-id="element-262" />
              <path d="m12 5 7 7-7 7" data-id="element-263" />
            </svg>
          </a>
        </motion.div>
      </div>
    </section>;
}